<template>
  <div class="third">
    <div class="third-formOne AlumniOpen">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">校友圈配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
      </div>
      <el-form
        @validate="validateValue"
        :show-message="false"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="86px"
        style="width: 60%; float: left"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px">
            <div class="forms-one">
              <div class="one-title">
                <div class="title-left">
                  <span class="left-icon">
                    <i class="el-icon-s-operation"></i>
                  </span>
                  <span class="left-content">业务管理</span>
                </div>
                <div class="title-right">
                  <el-button @click="Reset()" class="btn-two" type="default"
                    >重置</el-button
                  >
                  <el-button
                    @click="commit()"
                    class="btn-two"
                    type="primary"
                    v-el-disabel-repeat-click
                    >保存</el-button
                  >
                </div>
              </div>
              <div class="one-list">
                <div class="list-one-line">
                  <el-form-item
                    label="校友圈业务"
                    :rules="{
                      required: true,
                      message: `请选择校友圈业务`,
                      trigger: 'blur',
                    }"
                  >
                    <el-radio-group v-model="ruleForm.alumniMomentsStatus">
                      <el-radio :label="1">启用</el-radio>
                      <el-radio :label="0">关闭</el-radio> </el-radio-group
                    ><br />
                    <span
                      style="font-size: 12px; color: #aeaeb4"
                      v-if="ruleForm.alumniMomentsStatus == 0"
                      >关闭校友圈业务后，请设置对应的展示栏目</span
                    >
                  </el-form-item>
                  <el-form-item
                    label="底部菜单名称"
                    prop="alumniMomentsMenuTitle"
                    :rules="{
                      required: true,
                      message: `请输入底部菜单名称`,
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      class="list-input"
                      :maxlength="3"
                      v-model.trim="ruleForm.alumniMomentsMenuTitle"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="默认图标"
                    style="margin-top: 20px"
                    prop="idelIcon"
                  >
                    <el-upload
                      class="list-upload-img"
                      :limit="1"
                      action="/api/blade-platform/serviceInfo/upload"
                      :data="{ fileType: 1 }"
                      :on-preview="handlePictureCardPreview_P"
                      :on-remove="handleRemove_P"
                      :on-success="handleSuccess_P"
                      :on-error="hadleError_P"
                      :before-upload="beforeUpload_P"
                      :file-list="fileList_P"
                      accept=".jpg, .jpeg, .png"
                      list-type="picture-card"
                      :class="{ hide: hideUpload_P }"
                    >
                      <i class="el-icon-plus"></i>
                      <div class="list-upload-title">点击上传</div>
                      <div slot="tip" class="list-upload-tip">
                        支持.png、.jpg、.jpeg格式，建议尺寸 60px*60px
                      </div>
                    </el-upload>
                  </el-form-item>
                  <el-form-item label="选中图标" prop="activatedIcon">
                    <el-upload
                      class="list-upload-img"
                      :limit="1"
                      action="/api/blade-platform/serviceInfo/upload"
                      :data="{ fileType: 1 }"
                      :on-preview="handlePictureCardPreview_S"
                      :on-remove="handleRemove_S"
                      :on-success="handleSuccess_S"
                      :on-error="hadleError_S"
                      :before-upload="beforeUpload_S"
                      :file-list="fileList_S"
                      accept=".jpg, .jpeg, .png"
                      list-type="picture-card"
                      :class="{ hide: hideUpload_S }"
                    >
                      <i class="el-icon-plus"></i>
                      <div class="list-upload-title">点击上传</div>
                      <div slot="tip" class="list-upload-tip">
                        支持.png、.jpg、.jpeg格式，建议尺寸 60px*60px
                      </div>
                    </el-upload>
                  </el-form-item>
                  <el-form-item
                   v-if="ruleForm.alumniMomentsStatus == 0"
                    prop="alumniMomentsStatus"
                    label="我的动态状态"
                    :rules="{
                      required: true,
                      message: `请选择我的动态状态`,
                      trigger: 'blur',
                    }"
                  >
                    <el-radio-group v-model="ruleForm.myDynamicStatus">
                      <el-radio :label="1">启用</el-radio>
                      <el-radio :label="0">关闭</el-radio> </el-radio-group
                    ><br />
                    <span
                      style="font-size: 12px; color: #aeaeb4"
                      v-if="ruleForm.myDynamicStatus == 1"
                      >&lt;我的-我的动态>为校友圈模块的完整业务</span
                    >
                  </el-form-item>
                  <el-form-item
                    v-if="ruleForm.myDynamicStatus == 1  && ruleForm.alumniMomentsStatus == 0"
                    label="展示名称"
                    prop="displayName"
                    :rules="{
                      required: true,
                      message: `请输入展示名称`,
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      class="list-input"
                      :maxlength="8"
                      v-model.trim="ruleForm.displayName"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="forms-one" v-if="ruleForm.alumniMomentsStatus == 0">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">栏目配置<span style="color: #ff4d4f">(必填)</span></span>
              </div>
            </div>
            <div class="one-list" style="margin-left: 24px">
              <div class="add-row">
                <el-button icon="el-icon-plus" @click="updateConfirm(null)"
                  >新增</el-button
                >
                <!-- <span
                  >此处的栏目请提前进行用户信息的对接，<span
                    class="list-view-oneline"
                    style="color: #409eff; cursor: pointer"
                    @click="openUrl('https://www.baidu.com')"
                    >点击获取对接方式</span
                  >
                </span> -->
              </div>
              <div class="list-four-line">
                <el-table
                  class="third-tableThree"
                  :data="currentTableData"
                  border
                  stripe
                >
                  <template v-for="(val, key) in tableDataShow">
                    <el-table-column
                      v-if="val.needKeyValue"
                      :prop="val.key"
                      :label="val.column"
                      :key="key"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        <span v-if="val.key === 'status'">
                          <span
                            v-if="scope.row[val.key] == 1"
                            style="color: #33cc99"
                            >启用</span
                          >
                          <span
                            v-if="scope.row[val.key] == 0"
                            style="color: #ff4d4f"
                            >停用</span
                          >
                        </span>
                        <!-- <template v-if="val.key === 'sort'">
                          {{ scope.$index }}
                        </template> -->
                        <template v-if="val.key === 'viewPermission'">
                          {{ getlable(scope.row, val.key) }}
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-else
                      min-width="60px"
                      :prop="val.key"
                      :label="val.column"
                      :key="key"
                      :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                  </template>
                  <el-table-column min-width="100px" prop="state" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click="updateStatus(scope.row, scope.$index)"
                      >
                        {{ scope.row.status !== 1 ? "启用" : "停用" }}
                      </el-button>
                      <span class="tableThree-height-shu">
                        <span class="shu-item"></span>
                      </span>
                      <el-button
                        type="text"
                        size="small"
                        @click="updateConfirm(scope.row, scope.$index)"
                        :disabled="scope.row.editStatus === 'ALL'"
                        >编辑</el-button
                      >
                      <span class="tableThree-height-shu">
                        <span class="shu-item"></span>
                      </span>
                      <el-button
                        type="text"
                        size="small"
                        @click="deleteRowConfirm(scope.row, scope.$index)"
                        :disabled="scope.row.editStatus === 'ALL'"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div class="phon-right">
        <img v-if="ruleForm.alumniMomentsStatus == 1" class="phon-right-img" src="@/assets/xyqmkpz.png" alt="" />
        <img v-else class="phon-right-img" src="@/assets/xyqmkpz1.png" alt="" />
      </div>
    </div>
    <preview-modal
      :previewModal="dialogVisible"
      :previewImageUrl="dialogImageUrl"
      @previewClose="closePreview"
    ></preview-modal>
    <addAndColumn
      ref="addAndColumn"
      :modalTitle="modalTitle"
      :newModalVisible="newModalVisible"
      @closeNewTask="closeImport"
      @addNewTask="addNewTask"
      @updateClu="updateClu"
    >
    </addAndColumn>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
    >
    </notice-modal>
  </div>
</template>

<script>
import { getRoleList } from "@/store/appconfig/inforMationConfig"; //我的;
// import { unencrypt } from "@/router/encrypt";
import addAndColumn from "./addAndColumn";
import { setStore, getStore } from "@/utils/store";

export default {
  name: "formSeven",
  props: ["IDlist"],
  components: {
    addAndColumn,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!this.ruleForm.activatedIcon) {
        callback(new Error("请上传选中图标"));
      } else {
        // if (this.ruleForm.checkPass !== '') {
        // this.$refs.ruleForm.validateField('checkPass');
        // }
        callback();
      }
    };
    var validatePassP = (rule, value, callback) => {
      if (!this.ruleForm.idelIcon) {
        callback(new Error("请上传默认图标"));
      } else {
        // if (this.ruleForm.checkPass !== '') {
        // this.$refs.ruleForm.validateField('checkPass');
        // }
        callback();
      }
    };
    return {
      countNum: 1, //用于显示第一个错误
      rules: {
        schoolId: [
          { required: true, message: "请输入学校代码", trigger: "blur" },
        ],
        schoolName: [
          { required: true, message: "请输入学校名称", trigger: "blur" },
        ],
        fileList_S: [{ required: true, message: "请输入", trigger: "blur" }],
        fileList_P: [{ required: true, message: "请输入", trigger: "blur" }],
        activatedIcon: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
        idelIcon: [
          { required: true, validator: validatePassP, trigger: "blur" },
        ],
      },
      ruleForm: {
        alumniMomentsStatus: 1, //校友圈业务:默认开启
        activatedIcon: "", // 图标
        idelIcon: "", //图标
        alumniMomentsMenuTitle: "校友圈", //底部菜单提示
        myDynamicStatus: 1, //我的动态
        displayName: "我的动态", //我的动态
      },
      uploadFilter: [".jpg",'.jpeg','.png'], // 格式验证
      fileList_S: [], // 配图列表
      fileList_P: [], // 配图列表
      dialogVisible: false, //查看大图弹框显示
      dialogVisibleFields: false, //字段弹窗
      dialogImageUrl: "", //查看大图图片路径
      hideUpload_S: false, //手机图隐藏
      hideUpload_P: false, //手机图隐藏
      hideUpload: false,
      //====================================新增编辑栏目
      currentTableData: [],
      modalTitle: "",
      newModalVisible: false,
      clickIndex: 0, //点击编辑行的index
      //   &********弹框******************************
      agreeNotice: {},
      noticeType: 5, // 提示类型
      agreeContent: "知道了", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "确定启用删除吗？", // 提示信息
      noticeSpec: "删除后不可恢复，", // 标红提示
      noticeModal: false, // 提示弹窗
      //===================转化使用角色
      roleList: [], //所有的角色信息
      tableDataShow: [
        //列表表头
        {
          column: "名称",
          key: "name",
          needKeyValue: false,
          caseKey: "name",
        },
        {
          column: "链接",
          key: "url",
          needKeyValue: false,
          caseKey: "url",
        },
        {
          column: "顺序",
          key: "sort",
          needKeyValue: false,
          caseKey: "sort",
        },
        {
          column: "使用角色",
          key: "viewPermission",
          needKeyValue: true,
          caseKey: "viewPermission",
        },
        {
          column: "状态",
          key: "status",
          needKeyValue: true,
          caseKey: "status",
        },
      ],
    };
  },
  watch: {
    "fileList.length"() {
      this.fileList.length > 8
        ? (this.hideUpload = true)
        : (this.hideUpload = false);
    },
  },
  created() {
    this.detailQueryResConfig(); //获取业务管理的配置
    this.GetCurrentTableData(); //获取与我相关的关联业务
    this.getRoleList();
  },
  methods: {
    openUrl(url) {
      window.open(url);
    },
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false;
    },
    //=============================转换使用角色方法
    //获取使用角色的
    getlable(row, key) {
      let value = row[key];

      if (row["viewPermission"] == undefined) {
        value = "";
      }
      //   debugger
      let roleArr = row["viewPermission"].split(",");
      roleArr = roleArr.filter((item) => item);
      let roleNameArr = [];
      if (roleArr.length > 0) {
        roleArr.forEach((element) => {
          const [role] = this.roleList.filter(
            (item) => element == item.viewPermission
          );
          if (role) roleNameArr.push(role.name);
        });
      }
      value = roleNameArr.join("，");

      return value;
    },
    async getRoleList() {
      const {
        data: { result, msg, status },
      } = await getRoleList();
      console.log(result, msg, status);
      if (status == 1000) {
        const aaa = result.map((item) => {
          return {
            name: item.roleName,
            viewPermission: item.roleId,
          };
        });
        console.log(aaa);
        this.roleList = aaa;
      }
    },
    //==========================================
    //保存
    async saveAlumniStartInfoFN() {
      try {
        let param = {
          config: {
            alumniMomentsStatus: this.ruleForm.alumniMomentsStatus, //校友圈业务:默认开启
            // value: "", //中文提示语
            // valueEn: "", //英文提示语
            activatedIcon:
              this.ruleForm.activatedIcon.indexOf("img/find2.png") !== -1
                ? ""
                : this.ruleForm.activatedIcon, // 图标
            idelIcon:
              this.ruleForm.idelIcon.indexOf("img/find1.png") !== -1
                ? ""
                : this.ruleForm.idelIcon, // 图标
            alumniMomentsMenuTitle: this.ruleForm.alumniMomentsMenuTitle, //底部菜单提示
            myDynamicStatus: this.ruleForm.myDynamicStatus, //我的动态
            displayName: this.ruleForm.displayName, //我的动态
          },
          titleList: this.currentTableData,
        };
        console.log(param);
        // return
        const saveOrUpdateQueryResConfig = await this.$store.dispatch(
          "saveAlumniMomentConfig",
          param
        );
        console.log(saveOrUpdateQueryResConfig, "保存结果");
        if (saveOrUpdateQueryResConfig.data.status === 1000) {
          this.$message.success("保存成功");
          //   this.detailQueryResConfig();
          this.GetCurrentTableData();
        } else {
          this.$message.error(saveOrUpdateQueryResConfig.data.msg);
        }
      } catch (err) {
        console.log(err);
      }
    },
    //重置
    Reset() {
      this.$refs["ruleForm"].resetFields();
      this.fileList_S = [];
      this.fileList_P = [];
      this.hideUpload_S = false;
      this.hideUpload_P = false;
      this.$nextTick(() => {
        this.detailQueryResConfig();
        this.GetCurrentTableData();
      });
    },
    //====================================================================图片上传默认选中图
    //点击图片列表
    handlePictureCardPreview_S(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
      //   this.dialogImageUrl =
      //     (file.response && unencrypt(file.response.result)) || file.url;
      // console.log("点击了图片列表", file);
    },
    //移除
    handleRemove_S(file, fileList) {
      console.log(fileList);
      this.fileList_S = [];
      this.hideUpload_S = false;
      this.ruleForm.activatedIcon = "";
    },
    //上传之前
    beforeUpload_S(file) {
      this.hideUpload_S = true;
      let testSuffix = file.name.substring(file.name.lastIndexOf("."));
      let res = this.filterFileRes(testSuffix, this.uploadFilter);
      //   const imgsize = file.size / 1024 / 1024 <= 5;
      if (!res) {
        this.$message.error("图片格式错误，请根据提示上传");
        return false;
      }
      //    else if (!imgsize) {
      //     this.$message.error("上传图片最大5M, 请重新上传!");
      //     return false;
      //   }
    },
    // 验证格式
    filterFileRes(testSuffix, uploadFilter) {
      let matchingCount = false;
      uploadFilter.forEach((element) => {
        // console.log(element)
        if (element === testSuffix) {
          matchingCount = true;
        }
      });
      return matchingCount;
    },
    // 成功
    handleSuccess_S(file) {
      this.ruleForm.activatedIcon = file.data[0].oUrl;
    },
    // 上传失败
    hadleError_S(err) {
      console.log(err);
      this.$message.error("上传失败");
      this.hideUpload_S = false;
    },
    //========================================================================图片上传选中图标
    //点击图片列表
    handlePictureCardPreview_P(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
      // console.log("点击了图片列表", file);
    },
    //移除
    handleRemove_P(file, fileList) {
      this.fileList_P = [];
      this.hideUpload_P = false;
      this.ruleForm.idelIcon = "";
    },
    //上传之前
    beforeUpload_P(file) {
      this.hideUpload_P = true;
      const imgsize = file.size / 1024 / 1024 < 2;
      let testSuffix = file.name.substring(file.name.lastIndexOf(".")).toLowerCase()
      let res = this.filterFileRes(testSuffix, this.uploadFilter);
      if (!res) {
        this.$message.error("上传文件格式错误");
        return false;
      }
      if (!imgsize) {
        this.$message.error("图片大小在2M以内，请重新上传！");
        return false;
      }
    },
    // 成功
    handleSuccess_P(file) {
      console.log(file);
      this.ruleForm.idelIcon = file.data[0].oUrl;
    },
    // 上传失败
    hadleError_P(err) {
      this.$message.error(err);
      this.hideUpload_P = false;
    },
    // 关闭预览弹窗
    closePreview() {
      this.dialogVisible = false;
      this.dialogImageUrl = "";
    },
    //========================================================================
    // 获取详情
    async detailQueryResConfig() {
      // this.fileList_S=[]
      // this.fileList_P=[]
      const detailQueryResConfig = await this.$store.dispatch(
        "getAlumniMomentsConfig",
        {}
      );
      console.log(detailQueryResConfig, "详情");
      if (detailQueryResConfig.data.status === 1000) {
        if (detailQueryResConfig.data.result) {
          this.ruleForm.alumniMomentsStatus =
            detailQueryResConfig.data.result.alumniMomentsStatus;
          this.ruleForm.activatedIcon =
            detailQueryResConfig.data.result.activatedIcon ||
            window.location.origin + window.location.pathname + "img/find2.png";
          this.ruleForm.idelIcon =
            detailQueryResConfig.data.result.idelIcon ||
            window.location.origin + window.location.pathname + "img/find1.png";
          this.ruleForm.alumniMomentsMenuTitle =
            detailQueryResConfig.data.result.alumniMomentsMenuTitle;
          this.ruleForm.myDynamicStatus =
            detailQueryResConfig.data.result.myDynamicStatus;
          this.ruleForm.displayName =
            detailQueryResConfig.data.result.displayName;
          //   this.hideUpload_S = detailQueryResConfig.data.result.activatedIcon
          //     ? true
          //     : false;
          //   this.hideUpload_P = detailQueryResConfig.data.result.idelIcon
          //     ? true
          //     : false;
          this.hideUpload_S = true;
          this.hideUpload_P = true;
          if (detailQueryResConfig.data.result.activatedIcon) {
            this.fileList_S.push({
              url: detailQueryResConfig.data.result.activatedIcon,
            });
          } else {
            this.fileList_S.push({
              url:
                window.location.origin +
                window.location.pathname +
                "img/find2.png",
            });
          }
          if (detailQueryResConfig.data.result.idelIcon) {
            this.fileList_P.push({
              url: detailQueryResConfig.data.result.idelIcon,
            });
          } else {
            this.fileList_P.push({
              url:
                window.location.origin +
                window.location.pathname +
                "img/find1.png",
            });
          }
          //   this.currentTableData = detailQueryResConfig.data.result.titleList;
        } else {
          this.fileList_S = [];
          this.fileList_P = [];
          this.ruleForm = {
            alumniMomentsStatus: 1, //校友圈业务:默认开启
            activatedIcon: "", // 图标
            idelIcon: "", // 图标
            alumniMomentsMenuTitle: "", //底部菜单提示
            myDynamicStatus: 1, //我的动态
            displayName: "", //我的动态
          };
        }
      } else {
        this.fileList_S = [];
        this.fileList_P = [];
        this.ruleForm = {
          alumniMomentsStatus: 1, //校友圈业务:默认开启
          activatedIcon: "", // 图标
          idelIcon: "", // 图标
          alumniMomentsMenuTitle: "", //底部菜单提示
          myDynamicStatus: 1, //我的动态
          displayName: "", //我的动态
        };
        this.$message.error(detailQueryResConfig.data.msg);
      }
    },
    // 获取详情
    async GetCurrentTableData() {
      const GetCurrentTableData = await this.$store.dispatch(
        "GetCurrentTableData",
        {}
      );
      if (GetCurrentTableData.data.status != 1000) {
        this.$message.error(GetCurrentTableData.data.msg);
        return;
      }
      this.currentTableData = GetCurrentTableData.data.result;
      console.log(GetCurrentTableData, "详情");
    },
    // 提交表单
    commit() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate((valid) => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            return this.isHaveData();
          } else {
            return false;
          }
        });
      });
    },
    isHaveData() {
      if (this.ruleForm.alumniMomentsStatus == 0 && this.currentTableData.length < 1) {
        this.agreeNotice = () => {
          this.noticeModal = false;
          return

        //   this.saveAlumniStartInfoFN();
        };
        (this.noitceContent = ""), // 提示信息
          (this.noticeSpec = "关闭校友圈业务后，必须在<栏目配置>中添加栏目"), // 标红提示
          (this.noticeModal = true);
      } else {
        this.saveAlumniStartInfoFN();

      }
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //删除列表栏目
    deleteRowConfirm(rowData, index) {
      this.agreeNotice = () => {
        this.noticeModal = false;
        this.deleteRow(rowData.id);
      };
      (this.noitceContent = "确定删除吗？"), // 提示信息
        (this.noticeSpec = "删除后不可恢复，"), // 标红提示
        (this.noticeModal = true);
    },
    async deleteRow(index) {
      //   this.currentTableData.splice(index, 1);
      console.log(index);
      try {
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch("AlumniMomentTitleRemove", {
          id: index,
        });
        // this.newModalVisible = false;
        if (status === 1000) {
          this.$message.success("删除成功");
          this.GetCurrentTableData();
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //编辑d
    updateConfirm(rowData, index) {
      // debugger
      console.log(rowData, index);
      if (rowData) {
        this.modalTitle = "编辑";
        this.clickIndex = index;
      } else {
        this.modalTitle = "新增";
      }
      setStore({
        name: "AlumniOPenRowData",
        content: rowData,
        type: "session",
      });
      this.newModalVisible = true;
      this.$refs["addAndColumn"].Reset();
    },
    // 关闭新增栏目弹框
    // 取消导入
    closeImport() {
      this.newModalVisible = false;
    },
    async addNewTask(obj) {
      console.log(obj);
      try {
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch("AlumniMomentTitleAdd", obj);
        if (status === 1000) {
          this.$message.success("保存成功");
          this.newModalVisible = false;
          this.GetCurrentTableData();
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async updateClu(obj) {
      //   this.currentTableData.splice(this.clickIndex, 1);
      //   this.currentTableData.unshift(obj);
      //   this.newModalVisible = false;
      try {
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch("AlumniMomentTitleUpdate", obj);
        this.newModalVisible = false;
        if (status === 1000) {
          this.$message.success("保存成功");
          this.GetCurrentTableData();
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //更新栏目状态
    async updateStatus(rowData, index) {
      // debugger
      //   if (rowData.status == 1) {
      //     this.$set(this.currentTableData[index], "status", 0);
      //     return;
      //   }
      //   this.$set(this.currentTableData[index], "status", 1);
      let updataRowData = rowData;
      if (rowData.status == 1) {
        updataRowData.status = 0;
      } else {
        updataRowData.status = 1;
      }

      try {
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch(
          "AlumniMomentTitleUpdate",
          updataRowData
        );
        this.newModalVisible = false;
        if (status === 1000) {
          //   this.$message.success("保存成功");
          this.GetCurrentTableData();
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss">
.tableThree-height-shu {
  display: inline-block;
  padding: 0 4px;
  position: relative;
  .shu-item {
    position: absolute;
    width: 1px;
    height: 12px;
    background-color: #d4d4d7;
    display: inline-block;
    top: -10px;
  }
}
.AlumniOpen {
  .phon-right {
    position: relative;
    // border:1px solid red;
    width: 40%;
    display: inline-block;
    height: calc(100vh - 102px);
    border-left: 1px solid #dcdee2;
    img {
      // border: 1px solid red;
      width: 389px;
      height: 669px;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  .baseData-input-numbers {
    .el-input__inner {
      text-align: left;
    }
  }
  .add-row {
    margin-bottom: 15px;
    font-size: 12px;
    color: rgb(46, 63, 87);
    .el-button {
      margin-left: 0px !important;
      margin-right: 10px;
    }
  }
  .hide .el-upload--picture-card {
    display: none;
  }
}
</style>
